module.exports = __webpack_public_path__ + "static/img/hezuo01.23d39cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo01.jpg
// module id = n4Wl
// module chunks = 1